export default __webpack_public_path__ + "static/media/oktalogo.bdca2b1b.png";